import format from 'date-fns/format';
import differenceInDays from 'date-fns/differenceInDays';

export default (result) => {
  const { createdAt, updatedAt } = result;
  const resultDate = updatedAt || createdAt;
  const diffInDays = differenceInDays(new Date(), new Date(resultDate));
  if (diffInDays > 5) {
    return format(new Date(resultDate), 'do MMM yyyy');
  }
  if (diffInDays === 0) {
    return 'Updated Today!';
  }
  return `${diffInDays} days ago`;
};
